$(function(){

	var animationDuration = 125;

	var form = $('.shop-header-search-form'),
		mobileSearchFieldContainer = $('.shop-header-search-mobile'), // search form and search results
		// containerDesktop = $('.shop-header-search-desktop'), // search form desktop
		ajaxSearchResultsContainer = $('.shop-header-search-results-container'), // container for search results mobile and desktop
		input = form.find(':text'),
		btnCloseSelector = '.shop-header-search-btn-close',
		// btnClose = form.find(btnCloseSelector),
		// btnSubmitSelector = '.shop-header-search-btn-search',
		// btnSubmit = form.find(btnSubmitSelector),
		toggle = $('.shop-header-search-mobile-icon-toggle'),
		ajaxSearchResults = $('.shop-cms-ajax-search-results'), // actual search results (within container) mobile and desktop
		btnCloseSearchResultsContainer = $('.shop-header-search-results-container-btn-close');

	// mobile toggle button (icon maginifier)
	// when opening: open search input field / empty input / focus cursor
	// when closing: close search input field / close result container
	toggle.on('click', function() {
		if (mobileSearchFieldContainer.is(':visible')) {
			bodyScrollUnlock();
			ajaxSearchResultsContainer.slideUp(animationDuration, function(){
				mobileSearchFieldContainer.hide();
			});
		} else {
			if (ajaxSearchResultsContainer.is(':visible')) { // this is the case when the user changes the viewport width from desktop to mobile, while the results are open
				ajaxSearchResultsContainer.hide();
			}
			input.val('');
			mobileSearchFieldContainer.slideDown(animationDuration, function(){
				input.focus();
			});
		}
	});

	// mobile search field close button
	mobileSearchFieldContainer.on('click', btnCloseSelector, function(e){
		e.preventDefault();
		bodyScrollUnlock();
		ajaxSearchResultsContainer.slideUp(animationDuration, function(){
			mobileSearchFieldContainer.hide();
		});
	});

	// close button search results container (visible in desktop view only)
	btnCloseSearchResultsContainer.on('click', function(e){
		e.preventDefault();
		bodyScrollUnlock();
		ajaxSearchResultsContainer.slideUp(animationDuration);
	});

});
